import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLandingBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  language: Types.Scalars['String']['input'];
}>;


export type GetLandingBySlugQuery = { __typename?: 'Query', Landing: Array<{ __typename?: 'Landing', id: string, status?: string | null, terms_open_by_default?: boolean | null, theme?: string | null, bingo_promo_code?: string | null, spins_promo_code?: string | null, SEO_title?: string | null, SEO_description?: string | null, show_go_to_prize_btn?: boolean | null, hero_image?: { __typename?: 'directus_files', width?: number | null, height?: number | null, filename_disk?: string | null } | null, hero_image_mobile?: { __typename?: 'directus_files', width?: number | null, height?: number | null, filename_disk?: string | null } | null, translations?: Array<{ __typename?: 'Landing_translations_1', id: string, slug?: string | null, hero_heading?: string | null, hero_heading_2_combo?: string | null, hero_description?: string | null, hero_terms?: string | null, full_terms: string, hero_first_step?: string | null, hero_second_step?: string | null, hero_third_step?: string | null } | null> | null }> };


export const GetLandingBySlugDocument = gql`
    query getLandingBySlug($slug: String!, $language: String!) {
  Landing(
    filter: {translations: {slug: {_eq: $slug}}}
    limit: 1
    offset: 1
    page: 1
  ) {
    id
    status
    terms_open_by_default
    theme
    bingo_promo_code
    spins_promo_code
    SEO_title
    SEO_description
    show_go_to_prize_btn
    hero_image {
      width
      height
      filename_disk
    }
    hero_image_mobile {
      width
      height
      filename_disk
    }
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      id
      slug
      hero_heading
      hero_heading_2_combo
      hero_description
      hero_terms
      full_terms
      hero_first_step
      hero_second_step
      hero_third_step
    }
  }
}
    `;

/**
 * __useGetLandingBySlugQuery__
 *
 * To run a query within a React component, call `useGetLandingBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetLandingBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetLandingBySlugQuery, GetLandingBySlugQueryVariables> & ({ variables: GetLandingBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingBySlugQuery, GetLandingBySlugQueryVariables>(GetLandingBySlugDocument, options);
      }
export function useGetLandingBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingBySlugQuery, GetLandingBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingBySlugQuery, GetLandingBySlugQueryVariables>(GetLandingBySlugDocument, options);
        }
export function useGetLandingBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLandingBySlugQuery, GetLandingBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLandingBySlugQuery, GetLandingBySlugQueryVariables>(GetLandingBySlugDocument, options);
        }
export type GetLandingBySlugQueryHookResult = ReturnType<typeof useGetLandingBySlugQuery>;
export type GetLandingBySlugLazyQueryHookResult = ReturnType<typeof useGetLandingBySlugLazyQuery>;
export type GetLandingBySlugSuspenseQueryHookResult = ReturnType<typeof useGetLandingBySlugSuspenseQuery>;
export type GetLandingBySlugQueryResult = Apollo.QueryResult<GetLandingBySlugQuery, GetLandingBySlugQueryVariables>;